import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Analytics } from "@vercel/analytics/react";
import { DebugViewportOverlay } from "@/components/DebugViewportOverlay";
import { scrubAnalyticsUrl } from "@/lib/analyticsScrub";
import { router } from "@/router";
import { useAuthStore } from "@/stores/auth";
import { shouldRetryQuery } from "@/lib/apiError";
import { bindDemoQueryClient } from "@/lib/demoSession";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: shouldRetryQuery,
    },
  },
});
bindDemoQueryClient(queryClient);

function App() {
  const initialize = useAuthStore((s) => s.initialize);

  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {/* Superadmin-only live viewport diagnostics (PWA drag/band hunt). */}
      <DebugViewportOverlay />
      {/* Vercel Web Analytics: screen counts only. beforeSend drops token
          URLs and collapses ids/slugs (see lib/analyticsScrub.ts). Needs
          Web Analytics enabled on the Vercel project; 404s harmlessly until then. */}
      <Analytics
        mode={import.meta.env.PROD ? "production" : "development"}
        beforeSend={scrubAnalyticsUrl}
      />
    </QueryClientProvider>
  );
}

export default App;
